import { Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import LoginPage from "./modules/auth/pages/Login";
import ResetPasswordPage from "./modules/auth/pages/ResetPassword";
import CheckAuth from "./utils/CheckAuth";
import AppDashboard from "./pages/AppContainer";
import routes from "./utils/Routes";
import VerifyIdentityPage from "./modules/auth/pages/VerifyIdentity";
import OtpVerificationPage from "./modules/auth/components/OtpVerification/OtpVerification";
import { RequireAuth } from "./utils/RequireAuth";
import NotFound from "./pages/NotFound";
import WaitingPage from "./modules/meeting/pages/waiting";
import MeetingPage from "./modules/meeting/pages/meeting";
import PaymentLinkPage from "./modules/payment-link/pages/PaymentLink";
import IncompleteAccountPage from "./modules/auth/pages/IncompleteAccount";
import Dashboard from "./modules/dashboard/components/Dashboard";
import ConsentLinkPage from "./modules/consent-link/pages/ConsentLinkPage";

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

export default function AppRoutes() {
    return (
        <SentryRoutes>
            <Route
                path="/"
                element={
                    <RequireAuth>
                        <AppDashboard />
                    </RequireAuth>
                }
            >
                <Route index element={<Dashboard />} />
                {routes.map((item) => (
                    <Route
                        key={item.path}
                        path={item.path}
                        element={<item.component />}
                    />
                ))}
                <Route path="*" element={<NotFound />} />
            </Route>

            <Route
                path="/meeting/:sessionHistoryId/waiting-room"
                element={
                    <RequireAuth>
                        <WaitingPage />
                    </RequireAuth>
                }
            />
            <Route
                path="/meeting/:sessionHistoryId/join"
                element={
                    <RequireAuth>
                        <MeetingPage />
                    </RequireAuth>
                }
            />
            {/* <Route
                path="/settings/2fa"
                element={
                    <RequireAuth>
                        <TwoFactorAuthenticationPage />
                    </RequireAuth>
                }
            /> */}
            <Route path="/login" element={<LoginPage />} />
            <Route
                path="/reset-password"
                element={
                    <CheckAuth>
                        <ResetPasswordPage />
                    </CheckAuth>
                }
            />
            <Route
                path="/verify-identity"
                element={
                    <CheckAuth>
                        <VerifyIdentityPage />
                    </CheckAuth>
                }
            />
            <Route
                path="/otp-verification"
                element={
                    <RequireAuth>
                        <OtpVerificationPage />
                    </RequireAuth>
                }
            />
            <Route
                path="/incomplete-account"
                element={
                    <RequireAuth>
                        <IncompleteAccountPage />
                    </RequireAuth>
                }
            />
            <Route path="/pay" element={<PaymentLinkPage />} />
            <Route path="/consent-link" element={<ConsentLinkPage />} />
            <Route path="*" element={<NotFound />} />
        </SentryRoutes>
    );
}
